<div class="quota-card">
  <h3 class="card-title">{{ getMeatTypeName(quota.meatType) }}</h3>
  <div class="divider"></div>

  <div class="quota-info">
    <div class="quota-row">
      <span class="quota-label">{{ 'quota.totalLimit' | translate }}</span>
      <span class="quota-value">{{ getTons(quota.totalLimitVolume) }} тонн</span>
    </div>
    <div class="quota-row">
      <span class="quota-label">{{ 'quota.allocatedVolume' | translate }}</span>
      <span class="quota-value">{{ getTons(quota.allocatedVolume) }} тонн</span>
    </div>
    <div class="quota-row">
      <span class="quota-label">{{ 'quota.remainderVolume' | translate }}</span>
      <span class="quota-value">{{ getTons(quota.remainderVolume) }} тонн</span>
    </div>
  </div>

  @if (showButton()) {
    <div class="card-footer">
      @if (!isAuthenticated) {
        <button class="btn-apply" (click)="goToLogin()">
          {{ 'quota.applyForQuota' | translate }}
        </button>
      } @else if (isSupplier) {
        <button class="btn-apply" (click)="applyForQuota()" [disabled]="applyLoading">
          @if (applyLoading) {
            <mat-spinner diameter="18" style="display:inline-block;vertical-align:middle;margin-right:6px;"></mat-spinner>
          }
          {{ 'quota.applyForQuota' | translate }}
        </button>
      }
    </div>
  }
</div>
